import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { Button, Modal, Select } from 'redpoints-front-components/index';

import { linksManagementSearchEngineFetch } from '../../../actions/linksManagementActions';
import {
  getLinksManagementSearchEngineList,
  getLinksManagementSearchEngineListIsLoading,
} from '../../../reducers/tasks/linksManagement';
import { translate } from '../../../helpers/languageHelper';

const LinksManagementSearchEngineModal = ({
  isLoading,
  linksManagementSearchEngineFetch,
  onAccept,
  onCancel,
  searchEngineList,
}) => {
  const [selectedSearchEngine, setSelectedSearchEngine] = useState({});

  useEffect(() => {
    if (!isLoading && !searchEngineList) {
      linksManagementSearchEngineFetch();
    }
  }, [isLoading, linksManagementSearchEngineFetch, searchEngineList]);

  const handleAccept = useCallback(() => {
    if (selectedSearchEngine) {
      onAccept(selectedSearchEngine)();
    }
  }, [onAccept, selectedSearchEngine]);

  const handleChange = useCallback(
    searchEngineId => {
      const selectedSearchEngine = searchEngineList.find(
        searchEngine => searchEngine.searchEngineDomainId === searchEngineId
      );
      setSelectedSearchEngine(selectedSearchEngine);
    },
    [searchEngineList]
  );

  const searchEngineOptions = (searchEngineList || []).map(
    ({ url, searchEngineDomainId }) => ({
      searchEngineDomainId,
      url,
    })
  );

  return (
    <Modal
      visible={true}
      onCancel={onCancel}
      footer={
        <>
          <div />
          <Button
            aria-label="search-engine-button"
            disabled={!selectedSearchEngine.searchEngineDomainId}
            loading={isLoading}
            onClick={handleAccept}
            type="primary"
          >
            {translate('actions.save')}
          </Button>
        </>
      }
    >
      <Select
        aria-label="search-engine-select"
        data={searchEngineOptions}
        disabled={isLoading || !searchEngineList}
        label={translate('tasks.links_management.modal.search_engine_label')}
        mapping={{ key: 'searchEngineDomainId', value: 'url' }}
        onChange={handleChange}
        value={selectedSearchEngine.searchEngineDomainId}
      />
    </Modal>
  );
};

LinksManagementSearchEngineModal.propTypes = {
  isLoading: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  searchEngineList: PropTypes.arrayOf(
    PropTypes.shape({
      searchEngineDomainId: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
};

const mapStateToProps = state => ({
  isLoading: getLinksManagementSearchEngineListIsLoading(state),
  searchEngineList: getLinksManagementSearchEngineList(state),
});

export default connect(mapStateToProps, {
  linksManagementSearchEngineFetch,
})(LinksManagementSearchEngineModal);
